import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import UserGuide from '../../../components/UserGuide';

const UserGuideScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      {/* Header */}
      {/* <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 px-6 pt-6">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
              <BookOpen className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Knowledge Base</h1>
              <p className="text-gray-600 dark:text-gray-400 mt-1">
                Manage and organize knowledge base articles
              </p>
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            onClick={() => navigate('/agent/dashboard')}
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Button>
        </div>
      </div> */}

      {/* User Guide Content */}
      <UserGuide />
    </div>
  );
};

export default UserGuideScreen;
